<div class="label-preview-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>QR Label Vorschau</h2>
    <button mat-icon-button (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Label wird geladen...</p>
    </div>

    <div *ngIf="error" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="loadLabelPreview()">
        Erneut versuchen
      </button>
    </div>

    <div *ngIf="!loading && !error" class="preview-container space-y-4">
      <!-- Tailwind Card Preview (UI friendly) -->
      <div class="bg-white shadow rounded-lg p-4 border border-gray-200">
        <div class="flex flex-row gap-4 items-start" style="max-width: 99.1mm;">
          <div class="flex-1">
            <div class="flex items-start justify-between mb-2">
              <img [src]="logoUrl" alt="Logo" class="h-14 w-auto" />
              <div class="text-[10px] font-semibold text-gray-700">ID: {{ data?.standortId }}</div>
            </div>
            <div class="space-y-1">
              <div class="text-sm font-semibold leading-tight">{{ indicatorName }}</div>
              <div class="text-[11px] text-gray-600">{{ indicatorType }}</div>
              <div class="text-[12px] font-semibold">{{ indicatorNumber }}</div>
              <div class="flex items-center gap-2">
                <span class="inline-block border border-gray-700" [style.background-color]="colorHex" style="width:12px;height:12px;"></span>
                <span class="text-[10px] text-gray-700">{{ colorName }}</span>
              </div>
            </div>
          </div>
          <div class="shrink-0 flex items-center justify-center">
            <img [src]="qrImgUrl" alt="QR" class="h-40 w-40 object-contain" />
          </div>
        </div>
        <div class="text-center text-[10px] text-gray-500 mt-2">SmartHACCP - {{ today | date:'dd.MM.yyyy' }}</div>
      </div>

      <!-- Exact HTML (print) preview below, in iframe -->
      
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">Schließen</button>
    <button 
      mat-stroked-button 
      color="accent"
      (click)="openInNewTab()"
      [disabled]="loading || !!error">
      <mat-icon>open_in_new</mat-icon>
      In neuem Tab öffnen (HTML)
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="printLabel()"
      [disabled]="loading || !!error || !htmlContent">
      <mat-icon>print</mat-icon>
      Drucken
    </button>
  </div>
</div>


